export default __webpack_public_path__ + "static/media/icon-shanghai-renshe-ios.47cbb616.png";